import React from 'react'
import AccountBoxOutlinedIcon from '@mui/icons-material/AccountBoxOutlined';
import WorkTwoToneIcon from '@mui/icons-material/WorkTwoTone';
import LuggageTwoToneIcon from '@mui/icons-material/LuggageTwoTone';
import LocalHospitalTwoToneIcon from '@mui/icons-material/LocalHospitalTwoTone';
import DotsComponent from '../../DotsComponent';
const HRProjectCard = ({data, hardData}) => {
    console.log(data)
  return (
    <div id="hr-Child1-left-dn3">
    <DotsComponent/>
      <h3>{hardData.title}</h3>
      <div className='hr-project-child'>
        <div className='hr-project-child2'>
            <div className='hr-project-child3'>
            <AccountBoxOutlinedIcon style={{color:'#797979'}}/>
            <span>{hardData.para1}</span>
            </div>
            <p>{data.para1}</p>
        </div>
        <hr/>
        <div className='hr-project-child2'>
        <div className='hr-project-child3'>
            <WorkTwoToneIcon style={{color:'#797979'}}/>
            <span>{hardData.para2}</span>
            </div>
            <p>{data.para2}</p>
        </div>
        <hr/>
        <div className='hr-project-child2'>
        <div className='hr-project-child3'>
            <LuggageTwoToneIcon style={{color:'#797979'}}/>
            <span>{hardData.para3}</span>
            </div>
            <p>{data.para3}</p>
        </div>
        <hr/>
        <div className='hr-project-child2'>
        <div className='hr-project-child3'>
            <LocalHospitalTwoToneIcon style={{color:'#797979'}}/>
            <span>{hardData.para4}</span>
            </div>
            <p>{data.para4}</p>
        </div>
      </div>
    </div>
  )
}

export default HRProjectCard
